export default "__VITE_ASSET__coV2292v__"